<div class="budget-status-widget" (click)="openModal()" [class.editmodecheck]="isEditMode"
    [class.toggled-full]="(size === 'small' || size === 'full' || size === 'half' || size === 'medium') && !isResizing">
    <!-- Widget Header -->
    <header class="widget-header">
        <div class="title-wrapper">
            <div class="widget-title">{{ title }}</div>
        </div>

        <!-- Edit Mode Controls -->
        <div class="header-actions">
            <ng-container *ngIf="isEditMode">
                <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin
                    #editTrigger="cdkOverlayOrigin">
                    <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </header>

    <!-- Budget Categories -->
    <div class="budget-content">
        <ng-container *ngFor="let category of categories; trackBy: trackByCategory; let isLast = last">
            <!-- Category Item -->
            <div class="category-item">
                <!-- Category Header -->
                <div class="category-header">
                    <div class="icon-wrapper">
                        <img [src]="category.icon" class="category-icon" [alt]="category.name" />
                    </div>
                    <div class="category-info">
                        <div class="category-label">{{ category.name }}</div>
                        <div class="category-amount">{{ formatCurrency(category.budgetAmount) }}</div>
                    </div>
                </div>

                <!-- Progress Bar -->
                <div class="progress-wrapper">
                    <div class="progress-bar" [style.width]="getProgressWidth(category)"
                        [style.background-color]="category.color" [class.exceeded]="category.status === 'exceeded'">
                    </div>
                </div>

                <!-- Usage Info -->
                <div class="usage-info">
                    <div class="usage-label" [style.color]="category.color">USED</div>
                    <div class="usage-dot" [style.background-color]="category.color"></div>
                    <div class="usage-percentage" [style.color]="category.color">
                        {{ category.usedPercentage }}{{ category.status === 'exceeded' ? '+' : '' }}%
                    </div>
                </div>
            </div>

            <!-- Divider (not shown after last item) -->
            <div class="category-divider" *ngIf="!isLast">
                <img src="assets/icons/img-vector-567.svg" class="divider-line" alt="" />
            </div>
        </ng-container>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="categories.length === 0">
            <p>No budget data available</p>
        </div>
    </div>
</div>